var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.DistributorMap = LGFG.WF.DistributorMap || (function () {

    // Define settings defaults
    var _settings = {};

    var init = function (settings) {

        // Override settings defaults if specified
        if (typeof (settings) !== 'undefined') {
            _settings = settings;
        }

        var mapSettings = {
            getDirectionsText: (settings && settings.getDirectionsText !== 'undefined')? settings.getDirectionsText: 'Get directions',
            mapElementId: 'distributor-locator-map',
            mapConfigurationEndpoint: '/umbraco/surface/distributorlocatormap/getinitialmapconfiguration',
            mapMarkerEndpoint: '/umbraco/surface/distributorlocatormap/getresultsasmarkers',
            mapMarkerInfoWindowEndpoint: '/umbraco/surface/distributorlocatormap/getmarkerinfoview',
            mapMarkerListViewElementSelector: '#distributor-locator-list',
            mapMarkerListViewEndpoint: '/umbraco/surface/distributorlocatormap/getlistresultsview',
            mapMarkerListViewBeforeLoad: function() {
                // Uninitialise slick
                try {
                    $('.slider-navmaptab').slick('slickRemove', null, null, true);
                } catch (ex) { /* Do nothing */
                }
            },
            mapMarkerListViewAfterLoad: function() {
                // Initialise slick
                try {
                    $('.slider-navmaptab').slick('unslick');
                } catch (ex) { /* Do nothing */
                }
                $('.slider-navmaptab').slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    focusOnSelect: true,
                    vertical: true,
                    infinite: false
                });
                $('#distributor-locator-list .slick-slide').click(function(e) {
                    $('html,body').animate({ scrollTop: $('#distributor-locator-map').offset().top - 150 })
                });
            },
            filterReloadsMapMarkers: false,
            filterPreventsMapMoveReload: true,
            minZoomForListResults: 6
        };
        var filterSettings = {
            radiusControlSelector: '#distributor-filter-location-radius',
            locationSearchTextBoxSelector: '#distributor-filter-location-search',
            locationSearchSubmitSelector: '#distributor-filter-location-search-submit',
            currentLocationSelector: '#distributor-filter-current-location',
            clearSearchButtonSelector: '#distributor-filter-reset'
        };
        var _filter = LGFG.WF.DistributorMapFilter;
        LGFG.WF.Map.init(mapSettings, { filter: _filter, filterSettings: filterSettings });

    };

    return {
        init: init
    };
})();